<script>
    import Foot from "../../components/Foot.svelte";
    import FindBar from "../../components/FindBar.svelte";
    import Button from "../../components/Button.svelte";
    import GameCard from "../../components/gamecard/GameCard.svelte";
    import AdminBar from "../../components/AdminBar.svelte";

    const searchFunction = (criteria) => {
        console.log(criteria)
    }
</script>

<AdminBar/>

<main class="page-main">
    <h1>Portal</h1>
    <FindBar labelText="GameId" searchFunction={searchFunction}/>
    <div class="button-holder">
        <Button text="Create new game"/>
    </div>
    <div class="cards">
        <GameCard gameId="bjorn-to-be-wild-95" mathId="viking-hv-95" clientId="bjorn" engineId="magic-engine" mechanicId="viking" imgSrc="../assets/games/bjorn.png" enabled="true"/>
        <GameCard gameId="dr-acula-lv" mathId="book-lv-95" clientId="dr-acula" engineId="magic-engine" mechanicId="book-game" imgSrc="../assets/games/dr-acula.png" enabled="false"/>
        <GameCard gameId="dr-acula-hv" mathId="book-hv-95" clientId="dr-acula" engineId="magic-engine" mechanicId="book-game" imgSrc="../assets/games/dr-acula.png" enabled="true"/>
        <GameCard gameId="cleos-kitty-95" mathId="fairy-95-hv" clientId="cleos" engineId="magic-engine" mechanicId="fairy" imgSrc="../assets/games/cleos-kitty.png" enabled="true"/>
        <GameCard gameId="las-vegas-joy-95" mathId="classic-lv-95" clientId="vegas-joy" engineId="magic-engine" mechanicId="classic" imgSrc="../assets/games/las-vegas-joy.png" enabled="true"/>
        <GameCard gameId="buffalo-bills-95" mathId="animal-95-std" clientId="buffalo-bils" engineId="magic-engine" mechanicId="animal-game" imgSrc="../assets/games/buffalo-bills.png" enabled="true"/>
    </div>
</main>

<Foot/>

<style>
    h1 {
        margin: 0;
        padding-top: 10px;
    }

    .cards {
        display: flex;
        flex-flow: wrap;
        justify-content: center;
        gap: 8px;
    }

    .page-main {
        padding-bottom: calc(1.5 * var(--footer-height));
    }
</style>
